import { useSearchParams } from "react-router-dom";
import { XCircle, RotateCcw } from "lucide-react";
import PaymentStatusShell from "./PaymentStatusShell";
import PaymentSuccess from "./PaymentSuccess";
import { getPaymentQueryData } from "./paymentStatusQuery";

export default function PaymentFail() {
  const [searchParams] = useSearchParams();
  const { paySystemName, status, transactionID } = getPaymentQueryData(searchParams);
  const orderId = searchParams.get("orderId");

  // EPS returns through the API, which re-checks the payment with EPS before
  // redirecting. If EPS actually collected the money, the fail URL is wrong and
  // the confirmed status wins.
  if (status === "paid" || status === "refunded") return <PaymentSuccess />;

  // The order was created (and the cart emptied) before the gateway opened, so
  // a retry pays for that order rather than starting a new checkout.
  const retryHref = orderId ? `/order-details/${encodeURIComponent(orderId)}` : "/my-orders";

  return (
    <PaymentStatusShell
      icon={<XCircle size={40} />}
      tone="danger"
      badge="Payment Failed"
      title="Payment Unsuccessful"
      subtitle={`Your payment via ${paySystemName || "the selected method"} could not be completed. Your order is saved — you can try paying for it again.`}
      transactionID={transactionID}
      note="If money left your account it will be matched to your order automatically. If the issue persists, contact support with your transaction ID."
      actions={
        <>
          <a href={retryHref} className="ps-btn ps-btn-primary">
            <RotateCcw size={15} /> Try Again
          </a>
          <a href="/" className="ps-btn ps-btn-outline">
            Return Home
          </a>
        </>
      }
    />
  );
}
